<template>
  <app-layout></app-layout>
</template>

<script>
  import AppLayout from './components/app-layouts/app-responsive-layout'

  export default {
    components: {
      'app-layout': AppLayout
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// app.vue?43b5dddc